<template>
  <div>
    <FormCard
      v-model="company"
      @formSubmit="$emit('formSubmit', $event)">
      <CardForm
        :resource="company"
        resource-name="company"
        :section-title="$t('settings.notificationSettings')">
        <TextInput
          v-model="company.notification_email"
          name="company[notification_email]"
          :custom-label="$t('common.email')"
          :disclaimer="$t('settings.emailDisclaimer')" />
        <label class="custom-form-group-label">{{ $t('settings.receiveNotifications') }}</label>
        <SingleCheckbox>
          <CheckBox
            v-model="company.notify_on_complete_order"
            name="company[notify_on_complete_order]"
            :label="$t('settings.paidOrders')"
            :checked="company.notify_on_complete_order"
            :submitted-value="company.notify_on_complete_order"
            :unchecked-value="false" />
        </SingleCheckbox>
        <TextInput
          v-model="company.sms_originator"
          name="company[sms_originator]"
          :custom-label="$t('settings.smsOriginator')"
          :maxlength="11"
          :disclaimer="$t('settings.smsDisclaimer')" />
      </CardForm>

      <CardForm v-if="displayVoucherTemplates"
                :resource="company"
                resource-name="company"
                :section-title="$t('settings.defaultTemplates')">
        <div v-for="(templates, name, index) in voucherTemplates"
             :key="index"
             class="form-group custom-form-group">
          <label class="custom-form-group-label" :for="`${name}-default`">{{ name }}</label>
          <select
            :id="`${name}-default`"
            :name="`company[voucher_templates_attributes][${index}][id]`"
            class="custom-select custom-input">
            <option
              v-for="template in templates"
              :key="template.id"
              :value="template.id"
              :selected="template.default">
              {{ template.name }}
            </option>
          </select>
          <input type="hidden" :name="`company[voucher_templates_attributes][${index}][default]`" value="true">
        </div>
      </CardForm>

      <CardForm
        :resource="company"
        resource-name="company"
        :section-title="$t('settings.operaIntegration')">
        <ToggleButton
          v-model="company.opera_integration_enabled"
          name="company[opera_integration_enabled]"
          :label="$t('settings.enableOperaIntegration')"
          :checked="company.opera_integration_enabled" />
      </CardForm>
    </FormCard>
  </div>
</template>

<script>
import FormCard from "../../../shared/components/UI/FormCard.vue";
import CardForm from "../../../shared/components/UI/CardForm.vue";
import TextInput from "../../../shared/components/UI/TextInput.vue";
import SingleCheckbox from "../../../shared/components/UI/SingleCheckbox.vue";
import CheckBox from "../../../shared/components/UI/CheckBox.vue";
import ToggleButton from "../../../shared/components/UI/ToggleButton.vue";

export default {
  name: "SettingsForm",

  components: {
    FormCard,
    CardForm,
    TextInput,
    SingleCheckbox,
    CheckBox,
    ToggleButton
  },

  props: {
    company: { type: Object, required: true },
    voucherTemplates: { type: Object }
  },

  computed: {
    displayVoucherTemplates () {
      return Object.keys(this.voucherTemplates).length > 0;
    }
  }
};
</script>
